export default function IconNotion(props: { size?: number }) {
  const { size = 24 } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="3.5"
        fill="#ffffff"
        stroke="#191919"
        strokeWidth="1.6"
      />
      <path
        fill="none"
        stroke="#191919"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.5 16.5v-9l7 9v-9"
      />
    </svg>
  );
}
